import React from 'react';
import {Spinner as ReactSpinner} from 'reactstrap';

export default function Spinner() {
    return (<div className="spinner">
            <ReactSpinner animation="border" color="primary" />
    </div>

    );
}